import {
  getGetVisitsWaitingroomV2QueryKey,
  getVisitsWaitingroomV2,
} from 'api/generated/visit-controller-v2/visit-controller-v2'
import { apiErrorCodes } from '../../utils/apiHelper'
import {
  ALLERGY_NAME_NOT_UNIQUE_ERROR,
  ALLERGY_NAME_NOT_VALID_ERROR,
  ALLERGY_SEVERITY_NOT_VALID_ERROR,
  FORBIDDEN_ERROR,
  INTERNAL_SERVER_ERROR,
  TREAT_COMMUNICATION_ERROR,
  VISIT_NOT_FOUND_ERROR,
} from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  CHANGE_CURRENT_PATIENT_ACCOUNT_INFO,
  CHANGE_IS_VISIT_ENDED,
  CLEAR_PHONE_TOKEN,
  CLEAR_STALE_CALL_TOKENS,
  LEAVE_VISIT_ROOM,
  RESET_WAITING_ROOM_PAGE,
  SET_ERROR,
  SET_ERROR_ALLERGY,
  SET_FORCE_UPDATE_WAITING_ROOM,
  SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS,
  SET_IS_ROOM_SUCCESS_CREATED,
  SET_IS_VISIT_NOTES_SAVED_SUCCESS,
  SET_LOADING,
  SET_NEW_PROVIDER_PROFILE_SETTINGS,
  SET_PATIENT_TREAT_URL,
  SET_VISIT_INFO,
  SET_VISIT_ROOM,
  SUCCESS_VISIT,
  SET_PHONE_ERROR,
  CLEAR_PHONE_ERROR,
  text,
  ADD_VISIT_ORDER,
  SET_IS_VIDEO_DECLINED,
  SET_IS_REQUESTING_PERMISSIONS,
  SET_PERMISSIONS_GRANTED,
  SET_PERMISSIONS_DENIED,
  SET_IS_REQUESTING_ROOM_INFO,
  SET_PROVIDER_INITIATING_VISIT,
} from './WaitingRoomConstants'
import { client } from 'api/components/queryClient'
import { parseTimeZone } from 'utils/common'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setErrorAllergy(msg) {
  return {
    type: SET_ERROR_ALLERGY,
    payload: msg,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function forceUpdateWaitingRoom(value, timezone) {
  const tz = parseTimeZone(timezone)

  getVisitsWaitingroomV2({ timezone: tz })
    .then((response) => {
      client.setQueryData(getGetVisitsWaitingroomV2QueryKey({ timezone: tz }), response)
    })
    .catch(() => {})

  return {
    type: SET_FORCE_UPDATE_WAITING_ROOM,
    payload: value,
  }
}
export function setError(code = '', extra = null) {
  return {
    type: SET_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}
export function leaveVisitRoom() {
  return {
    type: LEAVE_VISIT_ROOM,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsVisitEnded(newStatus) {
  return {
    type: CHANGE_IS_VISIT_ENDED,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setPatientTreatUrl(newUrl) {
  return {
    type: SET_PATIENT_TREAT_URL,
    payload: newUrl,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setVisitRoom(value) {
  return {
    type: SET_VISIT_ROOM,
    payload: value,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsRoomSuccessCreated(newStatus) {
  return {
    type: SET_IS_ROOM_SUCCESS_CREATED,
    payload: newStatus,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setWaitingRoomLoading = (newStatus) => ({
  type: SET_LOADING,
  payload: newStatus,
})

export function reset() {
  return {
    type: RESET_WAITING_ROOM_PAGE,
  }
}

export function clearPhoneToken() {
  return {
    type: CLEAR_PHONE_TOKEN,
  }
}

export function clearStaleCallTokens() {
  return {
    type: CLEAR_STALE_CALL_TOKENS,
  }
}

export function successVisit() {
  return {
    type: SUCCESS_VISIT,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setVisitInfo = (payload) => ({
  type: SET_VISIT_INFO,
  payload,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsVisitNotesSavedSuccess = (value) => ({
  type: SET_IS_VISIT_NOTES_SAVED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPatientInstructionsSavedSuccess = (value) => ({
  type: SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getError(code) {
  switch (code) {
    case errorCodes.NO_CONNECTION:
      return getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)
    case ALLERGY_NAME_NOT_UNIQUE_ERROR:
      return getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE)
    case ALLERGY_NAME_NOT_VALID_ERROR:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Allergy name')

    case apiErrorCodes.ICD_CODE_COUNT_NOT_VALID:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.ICD_CODE)

    case ALLERGY_SEVERITY_NOT_VALID_ERROR:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Allergy Severity')

    case TREAT_COMMUNICATION_ERROR:
      return getUserFriendlyErrorMessage(errorCodes.TREAT_ERROR)

    case VISIT_NOT_FOUND_ERROR:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'visit')

    case apiErrorCodes.ICD_CODE_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, text.ICD_CODE)
    case FORBIDDEN_ERROR:
      return getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED)
    case INTERNAL_SERVER_ERROR:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)

    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setNewProviderProfileSettings = (newSettings) => ({
  type: SET_NEW_PROVIDER_PROFILE_SETTINGS,
  payload: newSettings,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const changeCurrentPatientAccountInfo = (newInfoConfig) => ({
  type: CHANGE_CURRENT_PATIENT_ACCOUNT_INFO,
  payload: newInfoConfig,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPhoneErrorAction = (message) => ({
  type: SET_PHONE_ERROR,
  payload: message,
})

export const clearPhoneErrorAction = () => ({
  type: CLEAR_PHONE_ERROR,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const addOrder = (order) => ({
  type: ADD_VISIT_ORDER,
  payload: order,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsVideoDeclined = (value) => ({
  type: SET_IS_VIDEO_DECLINED,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsRequestingPermissions = (value) => ({
  type: SET_IS_REQUESTING_PERMISSIONS,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPermissionsGranted = (value) => ({
  type: SET_PERMISSIONS_GRANTED,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPermissionsDenied = (value) => ({
  type: SET_PERMISSIONS_DENIED,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsRequestingRoomInfo = (value) => ({
  type: SET_IS_REQUESTING_ROOM_INFO,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setProviderInitiatingVisit = (value) => ({
  type: SET_PROVIDER_INITIATING_VISIT,
  payload: value,
})
